(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {

    var $usernameForm = $('#usernameForm'),
        $username = $usernameForm.find('[name="email"]'),
        $loginForm = $('#loginForm'),
        $usernameDisplay = $loginForm.find('#username-display'),
        $carousel = $('.carousel'),
        $backBtn = $('.step-back'),
        $ssoOpts = $('.sso-opts'),
        $nonSsoOpts = $('.non-sso-opts'),
        $ssoBtns = $ssoOpts.children('.btns');

    // pre-populate the username/email field
    if (_typeof(window.localStorage) == 'object') {
        $username.val(window.localStorage.getItem('loginUsername'));
    }

    // init carousel to cycle between steps
    $carousel.carousel({
        interval: false,
        wrap: false,
        keyboard: false
    });

    // toggle between steps with the back btn
    $backBtn.unbind().on('click', function (e) {
        e.preventDefault();
        $carousel.carousel('prev');
        $backBtn.fadeOut(150);
    });

    // default to focus on the username field
    $username.focus();

    // when the username form is submitted, do the SSO check and route accordingly
    $usernameForm.unbind().on('submit', function (e) {
        e.preventDefault();

        // remember the email for pre-populating
        if (_typeof(window.localStorage) == 'object') {
            window.localStorage.setItem('loginUsername', $username.val());
        }

        // make a call to check for an SSO option
        $.ajax({
            url: '/saml/ssocheck',
            method: 'POST',
            dataType: 'json',
            data: {
                email: $username.val()
            },
            success: function success(res) {
                if ((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && typeof res.ssos !== 'undefined' && typeof res.ssos.length == 'number' && res.ssos.length) {
                    // show the SSO options
                    $ssoBtns.html('');
                    $.each(res.ssos, function (i, sso) {
                        $ssoBtns.append('<a href="' + sso.url + '" class="login-button-blue sso-button">' + sso.name + '</a>');

                        // check if SSO only is enabled
                        if (sso.ssoOnly == 1) {
                            $nonSsoOpts.hide();
                        }
                    });
                    $ssoOpts.show();
                } else {
                    $ssoOpts.hide();
                }

                $carousel.carousel('next');
                $loginForm.find('[name="email"]').val($username.val());
                $usernameDisplay.html($username.val());
                $loginForm.find('[type="password"]').focus();
                $backBtn.fadeIn(150);
            },
            error: function error() {
                $carousel.carousel('prev');
            }
        });

        return false;
    });
})();

},{}]},{},[1]);
